import Api from 'libs/api';
import AuthService from 'services/Auth';

class DishOptionsApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/options`);
  }
}

export default DishOptionsApi;
